import { GetCurrentLanguageCode } from '~/constants/getters';
import { SetCurrentLanguageCode } from '~/constants/mutations';
import { UpdateCurrentLanguageCode } from '~/constants/actions';

const defaultState = () => ({
  currentLanguageCode: '',
});

const state = defaultState;

const getters = {
  [GetCurrentLanguageCode]: (state) => state.currentLanguageCode,
};

const mutations = {
  [SetCurrentLanguageCode]: (state, languageCode) => {
    state.currentLanguageCode = languageCode;
  },
};

const actions = {
  [UpdateCurrentLanguageCode]: ({ commit }, languageCode) => {
    commit(SetCurrentLanguageCode, languageCode);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
